import { isFeatureEnabled } from 'owa-feature-flags';

export default function shouldShowOwaBrandElement(shouldShowBrand: boolean) {
    if (isFeatureEnabled('sea-folderScope')) {
        if (shouldShowBrand) {
            document.getElementById('owaBranding_container').style.display = 'inherit';
        } else {
            document.getElementById('owaBranding_container').style.display = 'none';
        }
    }
}
